import { PayloadAction } from '@reduxjs/toolkit';
import { ENUM__redux_action } from '../../_base/ENUM__redux_action';
import { STATE__collections } from '../STATE__collections';

import { get_or_create_special_collection_info_by_workspace_id } from '../_methods/get_or_create_special_collection_info_by_workspace_id';

export const local_collection_special_info_set_current = (workspace_id: string): PayloadAction<string> => ({
  type: ENUM__redux_action.COLLECTIONS_SPECIAL_INFO_SET_CURRENT,
  payload: workspace_id,
});

export const init_local_collection_special_info_set_current = (state: STATE__collections, action: PayloadAction<string>) => {
  let workspace_id = action.payload;

  if (state.special_collections_info_current.workspace_id == workspace_id) return;

  let images_ids_workspace = get_or_create_special_collection_info_by_workspace_id(state, workspace_id);

  state.special_collections_info_current = images_ids_workspace;
};
